export const solutions = [
  {
    id: "surveillance",
    icon: "ri-shield-check-line",
    title: "Surveillance & Security Solutions",
    subtitle: "Body-Worn Cameras & Monitoring",
    description:
      "End-to-end security solutions featuring body-worn camera (BWC) devices and surveillance systems from Hytera — built for law enforcement, security teams, and field operations.",
    brands: ["Hytera"],
    color: "#1a1a1a",
    href: "/solutions/surveillance",
    image:
      "https://static.readdy.ai/image/8ef50732a893e16bbc98824684ca939c/d682a35dc53bc063a060c01c87a490f5.jpeg",
  },
  {
    id: "rugged",
    icon: "ri-cpu-line",
    title: "Rugged Computing Solutions",
    subtitle: "Mobile Workforce & Field Devices",
    description:
      "Ultra-durable tablets and laptops from Honeywell and Dell Rugged Pro designed to survive drops, water, dust, and extreme temperatures — powering teams in construction, logistics, and emergency response.",
    brands: ["Honeywell", "Dell Rugged Pro"],
    color: "#1a1a1a",
    href: "/solutions/rugged-computing",
    image:
      "https://static.readdy.ai/image/8ef50732a893e16bbc98824684ca939c/5b8860c0927237a0fc49d3ae69dad40d.jpeg",
  },
  {
    id: "arcfra",
    icon: "ri-stack-line",
    title: "Hyperconverged Infrastructure",
    subtitle: "VMware & Nutanix Alternative",
    description:
      "Arcfra delivers next-generation hyperconverged infrastructure (HCI) — a cost-effective, AI-ready alternative to VMware and Nutanix for Malaysian enterprises seeking scalable, high-performance compute and storage.",
    brands: ["Arcfra"],
    color: "#1a1a1a",
    href: "/arcfra-spotlight",
    image:
      "https://readdy.ai/api/search-image?query=modern%20enterprise%20hyperconverged%20server%20blades%20inside%20a%20clean%20data%20center%2C%20cool%20blue%20and%20white%20LED%20lighting%2C%20high%20performance%20computing%20hardware%2C%20professional%20commercial%20photography%2C%20sharp%20focus%2C%20minimal%20dark%20background%2C%20high%20detail%20technology&width=600&height=400&seq=sol3&orientation=landscape",
  },
  {
    id: "exagrid",
    icon: "ri-hard-drive-3-line",
    title: "Enterprise Backup & Recovery",
    subtitle: "Ransomware-Proof | Scale-Out Backup",
    description:
      "ExaGrid's purpose-built backup storage delivers the fastest recovery times, ransomware protection with an immutable landing zone, and a scale-out architecture that grows with your business — no forklift upgrades ever.",
    brands: ["ExaGrid", "Synology"],
    color: "#1a1a1a",
    href: "/exagrid-spotlight",
    image:
      "https://readdy.ai/api/search-image?query=enterprise%20data%20backup%20storage%20appliance%20hardware%2C%20clean%20white%20server%20equipment%20in%20modern%20data%20center%2C%20professional%20commercial%20photography%2C%20sharp%20focus%2C%20minimal%20white%20and%20gray%20background%2C%20high%20detail%20storage%20technology%20rack&width=600&height=400&seq=sol4&orientation=landscape",
  },
];

export const brands = [
  {
    name: "Hytera",
    category: "Communications & Body Cameras",
    logo: "ri-radio-line",
    description: "Leading manufacturer of professional mobile radio and body-worn camera solutions.",
  },
  {
    name: "ExaGrid",
    category: "Data Backup",
    logo: "ri-hard-drive-2-line",
    description: "Purpose-built backup storage with deduplication and instant recovery.",
  },
  {
    name: "Arcfra",
    category: "HCI & Cloud Infrastructure",
    logo: "ri-server-line",
    description: "Arcfra AECP full-stack HCI software — AVE, ABS, AKE, ANS, AFS modules. Gartner-recognised VMware alternative (2025), 1,000+ enterprise customers.",
  },
  {
    name: "Synology",
    category: "NAS & Cloud Storage",
    logo: "ri-cloud-line",
    description: "Network-attached storage and cloud management for businesses of all sizes.",
  },
  {
    name: "Honeywell",
    category: "Rugged Mobile Devices",
    logo: "ri-smartphone-line",
    description: "Enterprise-grade rugged mobile computers for demanding work environments.",
  },
  {
    name: "Dell Rugged Pro",
    category: "Rugged Laptops & Tablets",
    logo: "ri-macbook-line",
    description: "MIL-SPEC certified rugged laptops and tablets built for the toughest conditions.",
  },
];

export const stats = [
  { value: "500", suffix: "+", label: "Enterprise Clients Served" },
  { value: "6", suffix: "", label: "Brand Partners (3 Authorized + 3 Tech)" },
  { value: "98", suffix: "%", label: "Client Retention Rate" },
  { value: "12", suffix: "+", label: "Years of Industry Experience" },
];

export const industries = [
  {
    icon: "ri-shield-user-line",
    title: "Security & Law Enforcement",
    description: "Body cameras, real-time monitoring, and secure communication for public safety agencies and private security firms.",
    image: "https://readdy.ai/api/search-image?query=police%20officer%20wearing%20body%20worn%20camera%20on%20uniform%20vest%20at%20night%20patrol%2C%20urban%20law%20enforcement%20scene%2C%20professional%20documentary%20photography%2C%20dramatic%20contrast%20lighting%2C%20dark%20tones%20with%20warm%20amber%20street%20light%20accents%2C%20high%20detail%20realistic&width=600&height=480&seq=ind-home-law1&orientation=portrait",
  },
  {
    icon: "ri-building-2-line",
    title: "Construction & Field Services",
    description: "Rugged devices and mobile computing solutions that survive harsh job sites and keep field teams connected.",
    image: "https://readdy.ai/api/search-image?query=construction%20engineer%20in%20hard%20hat%20and%20safety%20vest%20reviewing%20plans%20on%20rugged%20tablet%20at%20a%20large%20building%20site%20with%20cranes%20and%20steel%20structures%20in%20background%2C%20golden%20hour%20lighting%2C%20professional%20industrial%20photography%2C%20photorealistic%2C%20warm%20tones&width=600&height=480&seq=ind-home-con1&orientation=portrait",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Healthcare",
    description: "Reliable devices and secure data solutions for healthcare personnel managing patient information on the go.",
    image: "https://readdy.ai/api/search-image?query=nurse%20in%20scrubs%20using%20a%20rugged%20handheld%20tablet%20device%20in%20a%20modern%20hospital%20corridor%2C%20clinical%20white%20environment%20with%20soft%20warm%20overhead%20lighting%2C%20clean%20minimalist%20healthcare%20setting%2C%20professional%20medical%20photography%2C%20photorealistic%2C%20sharp%20focus&width=600&height=480&seq=ind-home-hc1&orientation=portrait",
  },
  {
    icon: "ri-truck-line",
    title: "Logistics & Transportation",
    description: "Real-time tracking, rugged scanning, and communication tools for fleet management and warehouse operations.",
    image: "https://readdy.ai/api/search-image?query=warehouse%20worker%20in%20high%20visibility%20vest%20scanning%20parcels%20with%20a%20rugged%20barcode%20scanner%2C%20large%20modern%20distribution%20center%20interior%2C%20bright%20industrial%20overhead%20lighting%2C%20rows%20of%20shelving%20with%20boxes%2C%20professional%20commercial%20photography%2C%20photorealistic&width=600&height=480&seq=ind-home-log1&orientation=portrait",
  },
  {
    icon: "ri-government-line",
    title: "Government & Public Sector",
    description: "Compliant, secure, and durable solutions meeting the rigorous demands of government procurement standards.",
    image: "https://readdy.ai/api/search-image?query=government%20official%20in%20formal%20business%20attire%20working%20on%20secure%20laptop%20in%20elegant%20modern%20office%20with%20glass%20walls%20and%20city%20skyline%20view%2C%20professional%20corporate%20photography%2C%20soft%20natural%20daylight%2C%20neutral%20tones%2C%20photorealistic&width=600&height=480&seq=ind-home-gov1&orientation=portrait",
  },
  {
    icon: "ri-database-line",
    title: "IT & Data Management",
    description: "Enterprise backup, disaster recovery, and scalable storage infrastructure for data-critical organizations.",
    image: "https://readdy.ai/api/search-image?query=modern%20enterprise%20data%20center%20server%20room%20with%20illuminated%20rack%20servers%2C%20cool%20blue%20and%20white%20LED%20lighting%2C%20clean%20organized%20cable%20management%2C%20professional%20IT%20infrastructure%20photography%2C%20dramatic%20perspective%2C%20high%20detail%2C%20dark%20background%20with%20glowing%20hardware&width=600&height=480&seq=ind-home-it1&orientation=portrait",
  },
];

export const caseStudies = [
  {
    industry: "Law Enforcement",
    title: "City Police Force Deploys 1,200 Body Cameras",
    brand: "Hytera",
    result: "68% reduction in evidence dispute time",
    description:
      "A metropolitan police department integrated Hytera body-worn cameras across all patrol officers, streamlining evidence management and improving public accountability.",
  },
  {
    industry: "Construction",
    title: "Infrastructure Firm Equips 300 Field Engineers",
    brand: "Dell Rugged Pro",
    result: "40% faster project reporting",
    description:
      "A leading infrastructure company deployed Dell Rugged Pro tablets to field engineers, enabling real-time data capture and eliminating paper-based processes.",
  },
  {
    industry: "Financial Services",
    title: "Regional Bank Achieves Zero-Downtime Backup",
    brand: "ExaGrid & Arcfra AECP",
    result: "99.99% uptime during recovery drills",
    description:
      "A regional bank deployed ExaGrid and Arcfra AECP (using ABS block storage for primary workloads) to create a resilient backup architecture, achieving RPO=0 and sub-15-minute RTO, passing all disaster recovery audits.",
  },
];
